exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.shopInfoMag .el-message-box__headerbtn:focus .el-message-box__close,\n.shopInfoMag .el-message-box__headerbtn:hover .el-message-box__close {\n  color: #909399;\n}\n.shopInfoMag .el-button--default:hover,\n.shopInfoMag.el-button--default:focus {\n  background: #ffffff;\n  border: 1px solid #dcdfe6;\n  color: #606266;\n}\n.shopInfoMag .el-button--primary,\n.shopInfoMag .el-button--primary:hover,\n.shopInfoMag.el-button--primary:focus {\n  background-color: #0095f1;\n  border-color: #0095f1;\n  color: #fff;\n}\n", ""]);

// exports
